module.exports = __webpack_public_path__ + "img/easy.eb3084d.png";